import { createSlice } from "@reduxjs/toolkit"
import { initialState } from './../../initialState';


  
  export const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
      getAllBasketFunc: (state, action) => {
        state.getAllBasket = action.payload
      },
      setPinMapModal: (state, action) => {
        state.pinMapModal = action.payload
      },
      setSecondNavbar: (state, action) => {
        state.secondNavbar = action.payload
      },
      currentLocationFunc:(state, action) => {
          state.currentLocation = action.payload; 
      },
      updateAddressFunc: (state, action) => {
        state.updateAddress = action.payload;
      },
      useEffectTrigger: (state, action) => {
        state.useTrigger = action.payload;
      },
       setSiteSEttings:(state, action) => {
        state.siteSettings = action.payload 
       },
       homeAddressReChoice: (state, action) => {
        state.step = action.payload.step;
        state.openStatus = action.payload.openStatus;
        state.textStatus = action.payload.textStatus;
       },
       navbarColorStatus : (state,action) =>{
        state.navbarColor = action.payload;
       },
       setUserInfo: (state, action) => {
        state.userInfo = {...action.payload, fullName:`${action.payload.firstName} ${action.payload.lastName}`}
       },
       authModalOpen: (state, action) => {
        state.authModal = action.payload
       },
       setCurrentStage: (state, action) => {
        state.currentStage = action.payload
       },
       setUserChoises: (state, action) => {
        state.userChoises = action.payload
       },
       updateUserChoises: (state, action) => {
        state.userChoises = {...state.userChoises, ...action.payload}
       },
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const {getAllBasketFunc,authModalOpen, setPinMapModal, currentLocationFunc,setSecondNavbar, updateAddressFunc, useEffectTrigger, setSiteSEttings, homeAddressReChoice, navbarColorStatus, setUserInfo,setCurrentStage, setUserChoises, updateUserChoises } = generalSlice.actions
  
  export default generalSlice.reducer